import React, { useState } from 'react';
import AdminNav from './AdminNav';
import AdminSidebar from './AdminSidebar';
import './AdminLayout.css';

function AdminLayout({ 
  children, 
  user, 
  onLogout, 
  roleColor = '#667eea',
  dashboardTitle = 'Admin Center',
  menuItems = [],
  activeTab,
  onTabChange
}) {
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);

  const handleMobileSidebarOpen = () => {
    setIsMobileSidebarOpen(true);
  };

  const handleMobileSidebarClose = () => {
    setIsMobileSidebarOpen(false);
  };

  return (
    <div className="admin-layout">
      <AdminNav 
        user={user}
        onLogout={onLogout}
        roleColor={roleColor}
        dashboardTitle={dashboardTitle}
        onMenuToggle={handleMobileSidebarOpen}
      />

      <div className="admin-body">
        <AdminSidebar 
          activeTab={activeTab}
          onTabChange={onTabChange}
          menuItems={menuItems}
          roleColor={roleColor}
          isMobileOpen={isMobileSidebarOpen}
          onMobileClose={handleMobileSidebarClose}
        />

        <main className="admin-main">
          {children}
        </main>
      </div>
    </div>
  );
}

export default AdminLayout;
